//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

  data: function () {
    return {
      isOpenAddresses: false
    }
  },

  props: {
    stock: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isModification: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    filteredCitiesShops: function () {
      const adressessShops = this.stock?.address || [];
      const currentCityId = this.$store.state?.appState?.config?.city?.data?.id || this.$store.state?.appState?.config?.city?.model?.id;

      return adressessShops.filter((t) => Boolean(String(t?.cityId || t?.city_id) === String(currentCityId)))
    },
    isJJ: function () {
      return this.$store.state["local-settings"].isJJ || false
    },
    vars: function () {
      return this.$store.state.appState?.vars || {}
    },
    shopsList: function () {
      return this.$store.state["local-settings"].shopsList || []
    },

    iconStock: function () {
      if (this.stock.totalCountAddress <= 0) {
        return require('~/assets/svg/product/cross.svg')
      }

      return require('~/assets/svg/product/check-green.svg')
    },
    labelStock: function () {
      const count = this.stock.totalCountAddress;
      const word = this.$caseWords(count, [
        "салоне",
        "салонах",
        "салонах",
      ])

      if (count <= 0) {
        return `Под заказ`
      }

      if (!this.isModification) {
        return `В наличии&nbsp<span>в ${count} ${word}</span>`
      }

      return `В наличии&nbsp<span>в ${count} ${word}</span> (${this.stock.quantity || 0}шт.)`
    },

    pickDateLabel: function () {
      const userCityId = this.$store.state?.appState?.config?.city?.data?.id;
      if (!Boolean(this.shopsList.find((t) => t.city_id === userCityId))) {
        return "Пункт выдачи"
      }

      return "Забрать в салоне"
    }
  },

  methods: {

    openAddresses: function () {
      if (this.stock.totalCountAddress <= 0) {
        return null
      }

      this.isOpenAddresses = !this.isOpenAddresses;
    },

    openStore: function (store) {
      this.$emit("openStore", store);
    }

  }

}
